import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from "@mui/material";
import axios from "../axios";
import { useState } from "react";
import { useQuery } from "react-query";

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const ClassReport = () => {
  const [classGroup, setClassGroup] = useState(null);
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);

  const { data: classes } = useQuery("classes", () =>
    axios.get("/classes").then((res) => res.data)
  );

  const handleClassChange = (event) => {
    setClassGroup(event.target.value);
  };
  const handleYearChange = (event) => {
    setYear(event.target.value);
  };

  const { data: classReport, isLoading } = useQuery(
    ["classReport", classGroup, year],
    () =>
      axios("/reports/class", {
        params: {
          classId: classGroup,
          year: year,
        },
      }).then((res) => res.data),
    {
      enabled: !!classGroup,
    }
  );

  const getCellColor = (monthData) => {
    if (monthData.settled === true) {
      return "#4caf50"; // Green for fully settled
    } else if (monthData.settled === false && monthData.dueAmount > 0) {
      return "#ff9800"; // Orange for partially settled or pending
    } else {
      return "#f5f5f5"; // Light grey for no fee
    }
  };

  return (
    <Box>
      <Typography variant="h5" component="h2">
        Class Report
      </Typography>
      <Box display={"flex"} width={"500px"} gap={2} marginTop={2}>
        <FormControl fullWidth>
          <InputLabel id="select-class">Class</InputLabel>
          <Select
            labelId="select-class"
            id="class-select"
            value={classGroup}
            label="Class"
            onChange={handleClassChange}
          >
            {classes &&
              classes.map((cls) => (
                <MenuItem key={cls.id} value={cls.id}>
                  {cls.name}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel id="select-year">Year</InputLabel>
          <Select
            labelId="select-year"
            id="year-select"
            value={year}
            label="Year"
            onChange={handleYearChange}
          >
            {Array.from(
              { length: currentYear - 2023 + 1 },
              (_, i) => currentYear - i
            ).map((y) => (
              <MenuItem key={y} value={y}>
                {y}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      {isLoading && (
        <Box display="flex" justifyContent="center" marginTop={4}>
          <CircularProgress />
        </Box>
      )}

      {!classGroup ? (
        <Box marginTop={4}>
          <Typography color="textSecondary">
            Please select a class to view the report.
          </Typography>
        </Box>
      ) : null}

      {classReport && classReport.length > 0 && (
        <TableContainer
          component={Paper}
          sx={{ marginTop: 4, maxWidth: "100%", overflowX: "auto" }}
        >
          <Table size="small" sx={{ minWidth: 1400 }}>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    position: "sticky",
                    left: 0,
                    backgroundColor: "#fff",
                    zIndex: 1,
                  }}
                >
                  Student Name
                </TableCell>
                {months.map((month) => (
                  <TableCell
                    key={month}
                    align="center"
                    sx={{ fontWeight: "bold" }}
                  >
                    {month}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {classReport.map((student) => (
                <TableRow key={student.studentId}>
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: 0,
                      backgroundColor: "#fff",
                      zIndex: 1,
                    }}
                  >
                    {student.studentName}
                  </TableCell>
                  {student.monthly.map((monthData, index) => (
                    <TableCell
                      key={index}
                      align="center"
                      sx={{
                        backgroundColor: getCellColor(monthData),
                        color: monthData.settled === true ? "#fff" : "#000",
                      }}
                    >
                      {monthData.paidAmount > 0
                        ? monthData.paidAmount.toLocaleString()
                        : monthData.dueAmount > 0
                        ? "0"
                        : "-"}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {classReport && classReport.length === 0 && (
        <Box marginTop={4}>
          <Typography color="textSecondary">
            No students found for the selected class.
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default ClassReport;
